/**
 * Search Modal Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Search Modal guide.
 */
export const searchModalTourConfig = {
  id: 'search-modal-onboarding',
  storageKey: 'triad_tour_search_modal_completed',
  steps: [
    {
      id: 'search-input',
      target: '[data-tour="search-input"]',
      titleKey: 'tour.searchModal.inputTitle',
      descriptionKey: 'tour.searchModal.inputDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'search-results',
      target: '[data-tour="search-results"]',
      titleKey: 'tour.searchModal.resultsTitle',
      descriptionKey: 'tour.searchModal.resultsDesc',
      position: 'top',
      align: 'center'
    }
  ]
};

export default searchModalTourConfig;
